import { Component } from '@angular/core';
import {  NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { BaseAPIService } from '@app/Services/api.base.service';
import { message } from '@app/constants/messages';
import { label } from '@app/constants/labels';
@Component({
  selector: 'app-user-block',
  templateUrl: './user-block.component.html',
  styleUrls: ['./user-block.component.scss']
})

export class UserBlockComponent  {
  public message = message;
  public labels = label
  constructor(public activeModal: NgbActiveModal, private readonly auth: AuthenticationService,private readonly baseService: BaseAPIService) { }

  
  CloseBlockedUserModal(){
    this.auth.logout();
  }

}
